import L from "leaflet";
import "leaflet-draw";
import i18n from "./index";

// The draw toolbar reads its texts from the global L.drawLocal.
const ENGLISH = JSON.parse(JSON.stringify(L.drawLocal));

const localized = (node, path) =>
  typeof node === "string"
    ? i18n.t(`draw.${path}`, { defaultValue: node })
    : Object.fromEntries(
        Object.entries(node).map(([key, value]) => [
          key,
          localized(value, path ? `${path}.${key}` : key),
        ]),
      );

// Takes effect when the toolbar is next shown.
const apply = () => {
  L.drawLocal = localized(ENGLISH, "");
};
apply();
i18n.on("languageChanged", apply);
